import { action, observable } from 'mobx'
import { message } from 'hljd'
import Api from '@api/xiu_yan/serviceAccount'

class Store {
  @observable visible = false
  @observable id

  @action
  changePwd = id => () => {
    this.visible = !this.visible
    this.id = id

    if (this.visible) {
      this.params = {
        password: '',
        confirm: ''
      }
    }
  }

  handleOk = () => {
    this.form.validateFields(errors => {
      if (!errors) {
        let params_submit = Object.assign({}, this.params, {
          confirm: undefined
        })
        this.doChange(params_submit)
      }
    })
  }

  doChange = async params_submit => {
    const { id } = this
    const { success } = await Api.modifyApi({ ...params_submit, id })
    if (success) {
      message.success('修改成功！')
      this.changePwd()()
    }
  }

  form
  @observable
  params = {
    password: '',
    confirm: ''
  }
  @observable confirmDirty = false

  formValsChange = (props, values) => {
    this.setParams(values)
  }
  setParams = values => {
    this.params = { ...this.params, ...values }
  }
}
export default new Store()
